var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MonitorLayoutTemplate", {
    attrs: {
      table_title: _vm.table_title,
      is_show_chart_dialog: _vm.is_show_chart_dialog
    },
    scopedSlots: _vm._u(
      [
        {
          key: "datetime",
          fn: function() {
            return [
              _c("QpeDatetime", {
                attrs: {
                  props_date: _vm.date,
                  props_time: _vm.time,
                  name: _vm.default_value
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time
                }
              })
            ]
          },
          proxy: true
        },
        _vm.default_value == 91
          ? {
              key: "signs",
              fn: function() {
                return [
                  _c("MonitorSigns", {
                    attrs: {
                      data: _vm.sign_data,
                      sort_type: "city_case",
                      is_show_raw_html: true,
                      hide_alert_remarks: true
                    }
                  })
                ]
              },
              proxy: true
            }
          : null,
        _vm.default_value == 91
          ? {
              key: "filter_condition_options",
              fn: function() {
                return [
                  _c("MonitorOptionSet", {
                    ref: "monitor_option_set",
                    attrs: { option_set: _vm.option_set },
                    on: { filter_data: _vm.filter_data }
                  })
                ]
              },
              proxy: true
            }
          : null,
        {
          key: "description",
          fn: function() {
            return [
              _vm.default_value == 329
                ? _c("div", { staticClass: "align-center-items" }, [
                    _c("span", {
                      staticClass: "description-dot",
                      staticStyle: { background: "#FF0000" }
                    }),
                    _vm._v(" (50dBZ超過4格網格後示警)​\n        ")
                  ])
                : _vm._e()
            ]
          },
          proxy: true
        },
        {
          key: "data_table",
          fn: function(slot_props) {
            return [
              _c("QpeDatatable", {
                attrs: {
                  data: _vm.table_data,
                  headers: _vm.header,
                  name: _vm.default_value,
                  error_text: _vm.error_text,
                  search: slot_props.search,
                  should_draw_diagram_header: _vm.should_draw_diagram_header,
                  enable_diagram_slot: true,
                  should_display_info_header_key_value:
                    _vm.should_display_info_header_key_value,
                  generate_tooltop_display_info:
                    _vm.generate_tooltop_display_info_for_table,
                  should_show_raw_html_header: _vm.should_show_raw_html_header,
                  show_download_pdf_btn: true,
                  is_show_chart_dialog_parent: _vm.is_show_chart_dialog
                },
                on: {
                  "update-time": _vm.update_time,
                  "change-parent-date-time": _vm.change_parent_date_time,
                  "open-chart": _vm.assign_chart_component,
                  "update:is_show_chart_dialog_parent": function($event) {
                    _vm.is_show_chart_dialog = $event
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "diagram_dialog",
                      fn: function(ref) {
                        var close_dialog = ref.close_dialog
                        return [
                          _vm.is_show_chart_dialog
                            ? _c("GisChart", {
                                attrs: {
                                  id: "belongs_monitor_chart",
                                  chart_options: _vm.chart_options,
                                  default_variable: _vm.$t(
                                    "__rainfall.rainfall"
                                  ),
                                  prop_rain_selected: _vm.current_table_header
                                },
                                on: { "close-chart-dialog": close_dialog }
                              })
                            : _vm._e()
                        ]
                      }
                    },
                    {
                      key: "table_description",
                      fn: function() {
                        return [
                          _vm.default_value == 332
                            ? _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "\n                        監測範圍："
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                        馬太鞍溪堰塞湖(23.69256°N , 121.30594°E)直徑15公里，共計156格點"
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                        馬太鞍溪中游(23.691992°N , 121.363103°E)直徑5公里，共計17格點"
                                  ),
                                  _c("br"),
                                  _vm._v(
                                    "\n                        馬太鞍溪橋(23.68871°N , 121.40896°E)直徑3公里，共計7格點"
                                  ),
                                  _c("br")
                                ]),
                                _vm._v(" "),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "\n                        警戒標準："
                                  ),
                                  _c("br"),
                                  _vm._v("\n                        預警(黃) "),
                                  _c("span", {
                                    staticClass: "description-dot",
                                    staticStyle: { background: "#ffff00" }
                                  }),
                                  _vm._v(
                                    "：各監測範圍出現雷達回波訊號，且強度達30dBZ，回波值所占的面積達60%，持續時間10分鐘，進行預警。"
                                  ),
                                  _c("br"),
                                  _vm._v("\n                        警戒(橙) "),
                                  _c("span", {
                                    staticClass: "description-dot",
                                    staticStyle: { background: "#eda12f" }
                                  }),
                                  _vm._v(
                                    "：各監測範圍雷達回波訊號增強至40dBZ，回波值所占的面積達60%，持續時間10分鐘，進行警戒。"
                                  ),
                                  _c("br"),
                                  _vm._v("\n                        行動(紅) "),
                                  _c("span", {
                                    staticClass: "description-dot",
                                    staticStyle: { background: "#f00" }
                                  }),
                                  _vm._v(
                                    "：各監測範圍雷達回波訊號增強至50dBZ，回波值所占的面積達60%，持續時間10分鐘，進行行動。"
                                  ),
                                  _c("br")
                                ])
                              ])
                            : _c("div", [
                                _c("span", [
                                  _vm._v(
                                    "1. 10分鐘、1小時、...、24小時為雷達定量降水估計QPE。"
                                  )
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "2. 採用依據參考雨量站之雨量計算而得的有效雨量做為警示值。"
                                  )
                                ])
                              ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              })
            ]
          }
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }